import api from 'service/api'

const dponetAPI = api.create('dponet')

const create = async (data) => {
  return await dponetAPI.post('/monitoring_management_pmcs', {
    monitoringManagementPmc: data,
  })
}

const list = async (params) => {
  return await dponetAPI.get('/monitoring_management_pmcs', {
    params,
  })
}
const show = async ({ monitoringManagementPmcId = '', ...params }) => {
  return await dponetAPI.get(
    `/monitoring_management_pmcs/${monitoringManagementPmcId}`,
    {
      params,
    },
  )
}

const update = async ({ monitoringManagementPmcId = '', ...params }) => {
  return await dponetAPI.put(
    `/monitoring_management_pmcs/${monitoringManagementPmcId}`,
    {
      monitoringManagementPmc: params,
    },
  )
}

export default {
  create,
  list,
  show,
  update,
}
